import React from 'react';
import { motion } from 'framer-motion';

const Technology = () => {
  return (
    <section className="prose prose-invert max-w-none">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
      >
        <h2 className="text-2xl font-bold mb-6">From Pneumatics and Hydraulics to Electric</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          <div>
            <p className="text-lg leading-relaxed">
              The transition from pneumatics and hydraulics to electric systems in animatronics reflects a broader shift seen in industrial automation, automotive, and aerospace industries. Historically, automation relied heavily on pneumatic and hydraulic systems for their simplicity and high force capabilities. However, the industry has increasingly embraced electric actuators and motors for their superior precision, lower maintenance requirements, and improved energy efficiency. Animatronics, at their core, are essentially industrial automation equipment covered in fur, skin, or other thematic materials to bring characters to life. This close connection means that as industrial automation shifts toward all-electric systems, animatronics naturally follow suit.
            </p> 
            <p className="text-lg leading-relaxed">
              Today, animatronics utilize many of the same advanced components as industrial automation, including servomotors, linear actuators, industrial-grade ball screws, bearings, and aerospace-grade materials. These components are selected to withstand millions of cycles, ensure reliability, and facilitate easy maintenance. The adoption of electric technology has enabled smoother, quieter, and more lifelike motion, with systems designed for precise, fluid movements. While the upfront costs can be higher, the lower maintenance demands and overall performance benefits of all-electric systems are driving the evolution of modern animatronics, making them more sustainable and adaptable for a variety of applications.
            </p>
          </div>
          <div>
            <img
              src="/images/animatronic-tech.webp"
              alt="Advanced animatronic technology components"
              className="w-full rounded-lg"
            />
          </div>
        </div>
      </motion.div>
    </section>
  );
};

export default Technology;